import PatientItem from './PatientItem';

export default PatientItem;
